module.exports = __webpack_public_path__ + "img/otrosIngresos.b1829bf9.png";